import React, { useState } from 'react'
import Button from "@mui/material/Button";
import Axios from "axios";
import { API_URL_UMS } from '../../../Constant';
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions'

const DialogContent = withStyles(() => ({
  root: {
    padding: '25px',
    textAlign: 'center',
    width: '437px',
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    textAlign: 'center',
    marginTop: '20px',
    display: 'block',
  },
}))(MuiDialogActions)

const DeleteRolePermission = (props) => {
  const { userID } = props;
  const [attributetype, setAttributetype] = useState("")
  const [attribute, setAttribute] = useState("")
  const [roleList, setRoleList] = useState([])
  const [permissionList, setPermissionList] = useState([])
  const [deleteMessage, setdeleteMessage] = useState("")
  const [open, setOpen] = useState(false)
  const [deletedMessage, setDeletedMessage] = useState("")
  const [atError, setAtError] = useState("")
  const [atTypeError, setAtTypeError] = useState("")

  const wantToDelete = () => {
    setOpen(false)
    const attributeObj = JSON.parse(attribute)
    console.log("attributeObj : ", attributeObj)
    let atb = attributetype === "Role" ? attributeObj.role : attributeObj.permission;
    let atbId = attributetype === "Role" ? attributeObj.userId : attributeObj.id;
    Axios({
      method: "DELETE",
      url: `${API_URL_UMS}audit/roleOrPermission?attributeType=${attributetype}&attributeValue=${atb}&attributeId=${atbId}&userId=${userID}&referenceNumber=Ref12er`,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setOpen(false)
        setDeletedMessage(response.data)
        setTimeout(() => {
          setDeletedMessage("")
          setAttributetype("")
          setAttribute("")
        }, 3000)
      })
      .catch((err) => {
      });
  }


  const onDeleteSubmit = (e) => {
    e.preventDefault()
    setAtError("")
    setAtTypeError("")
    if (attributetype === "" && attribute === "") {
      setAtError("Required")
      setAtTypeError("Required")
      return 0;
    }
    if (attributetype === "" || attributetype === "Select Attribute type") {
      setAtError("Required")
      return 0;
    }
    if (attribute === "" || attribute === "Attribute") {
      setAtTypeError("Required")
      return 0;
    }

    const attributeObj = JSON.parse(attribute)
    let atb = attributetype === "Role" ? attributeObj.role : attributeObj.permission;
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      `${API_URL_UMS}audit/simulateBeforeDelete?attributeType=${attributetype}&attributeValue=${atb}`,
      requestOptions
    )
      .then((response) => {
        if (response.data) {
          setdeleteMessage(response.data)
          setOpen(true)
        } else {
          wantToDelete()
        }
      })
      .catch((error) => {
      });
  }

  const onSelectAttribute = (e) => {
    setAtError("")
    setAtTypeError("")
    setRoleList([])
    setPermissionList([])
    setAttributetype(e.target.value)
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    if (e.target.value === "Role") {
      Axios.get(
        `${API_URL_UMS}audit/role`,
        requestOptions
      )
        .then((response) => {
          setRoleList(response.data)
        })
        .catch((error) => {

        });
    } 
    if (e.target.value === "Permission") {
      const requestOptions = {
        headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        },
      };
      Axios.get(
        `${API_URL_UMS}audit/permissions`,
        requestOptions
      )
        .then((response) => {
          setPermissionList(response.data)

        })
        .catch((error) => {
        });
    }
  }

  return (
    <>
      <div className='row mt-3'>
        <div className='col-md-6 mx-auto card p-3'>
          <form className='formField'>
            <div className="form-group row">
              <label htmlFor="validationScreen" className="col-sm-4 col-form-label">Attribute type<span className='text-danger'>*</span> :</label>
              <div className="col-sm-6">
                <select onChange={onSelectAttribute} value={attributetype} name="attributetype" class={`form-select ${atError && "formValidation"}`} aria-label="Default select example">
                  <option selected>Select Attribute type</option>
                  <option value="Role">Role</option>
                  <option value="Permission">Permission</option>
                </select>
                <small id="validationSubScreen" class="form-text text-right text-danger">{atError}</small>
              </div>

            </div>
            <div className="form-group row">
              <label htmlFor="validationSubScreen" className="col-sm-4 col-form-label">Attribute<span className='text-danger'>*</span> :</label>
              <div className="col-sm-6">
                <select onChange={(e) => setAttribute(e.target.value)} value={attribute} name="attribute" class={`form-select ${atTypeError && "formValidation"}`} aria-label="Default select example">
                  <option selected>Select Attribute</option>
                  {roleList && roleList.length > 0 && roleList.map((item) => <option value={JSON.stringify(item)}>{item.role}</option>)}
                  {permissionList && permissionList.length > 0 && permissionList.map((item) => <option value={JSON.stringify(item)}>{item.permission}</option>)}
                </select>
                <small id="validationSubScreen" class="form-text text-right text-danger">{atTypeError}</small>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-success text-center">
                <span >{deletedMessage}</span>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-center">
                <Button
                  variant="contained"
                  className="btncolor"
                  size="small"
                  type="submit"
                  sx={{ m: 1 }}
                  onClick={onDeleteSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className='dialog-boxes'>
        <Dialog aria-labelledby='customized-dialog-title' open={open}>
          <DialogContent>
            <Typography>
              {deleteMessage}
            </Typography>
            <DialogActions style={{ display: "inline-block" }}>
              <div className='create_link d-flex text-center'>
                <Button
                  variant="contained"
                  className="btncolor"
                  size="small"
                  type="submit"
                  sx={{ m: 1 }}
                  onClick={wantToDelete}
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  className="btncolor"
                  size="small"
                  type="submit"
                  sx={{ m: 1 }}
                  onClick={() => setOpen(false)}
                >
                  No
                </Button>
              </div>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>

    </>
  )
}

export default DeleteRolePermission